"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borriana": {
    "9370c3d1": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "skipSearch": false
    }],
    "canton-rossetti": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ed38dd7": [{
      "hkey": "ca0b9786",
      "slug": "becce",
      "name": "Becce",
      "primary": true,
      "skipSearch": false
    }],
    "case-becce": [{
      "hkey": "ca0b9786",
      "slug": "becce",
      "name": "Becce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9943ee87": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "skipSearch": false
    }],
    "castellone": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "042b8989": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "skipSearch": false
    }],
    "massa": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72cd746a": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2c302b8e": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "skipSearch": false
    }],
    "rivalta": [{
      "hkey": "395ea658",
      "slug": "borriana",
      "name": "Borriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;